module.exports = __webpack_public_path__ + "static/media/zw.02ec4110.svg";